import React from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import './Privacy.css';
import SEO from '../components/SEO';

function Privacy() {
  return (
    <div className="privacy-page-wrapper">
      <SEO 
        title="Privacy Policy - Data & Security Disclosures"
        description="Review 9tro Ride's policies on data collection, user location tracking, storage practices, and security rules."
        url="https://www.9troride.com/privacy"
      />
      <Navbar showSubNavbar={false} />

      <section className="legal-hero">
        <div className="legal-hero-container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: July 22, 2026</p>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="legal-container">
          <div className="legal-text">
            <h2>1. Information We Collect</h2>
            <p>At 9tro Ride, we collect information to match riders with drivers, connect customers with chefs, and process logistics deliveries. This includes:</p>
            <ul>
              <li><strong>Profile Information:</strong> Name, email address, phone number, and avatar photos.</li>
              <li><strong>Location Data:</strong> Real-time location data from your browser or device to calculate routes and display live driver/courier pins on the map.</li>
              <li><strong>Payment Records:</strong> Transaction records, invoice totals, and basic wallet details. Card processing is securely offloaded to Paystack.</li>
            </ul>

            <h2>2. How We Use Your Data</h2>
            <p>Your data is processed to deliver transport and kitchen orders, handle checkout flows, and secure accounts. We use data to:</p>
            <ul>
              <li>Determine real-time location parameters for picking up and dropping off packages.</li>
              <li>Allow internal driver-to-passenger active messaging and call options.</li>
              <li>Improve app performance, handle network debugging states, and block spam requests.</li>
            </ul>

            <h2>3. Sharing Your Information</h2>
            <p>We do not sell your personal information. To match orders, we share necessary trip records (such as names and drop-off coordinates) with matching partner drivers and couriers. Chefs receive only order items and basic customer details to prepare meals.</p>

            <h2>4. Cookies & Local Storage</h2>
            <p>We use local browser storage and secure session states (e.g. <code>localStorage</code>) to maintain active user login sessions, store cart items, and save addresses. This is required for checkout and settings pages to load cleanly.</p>

            <h2>5. Contact Us</h2>
            <p>If you have any questions regarding data usage or wish to delete your account data, please contact our support team at <strong>privacy@9troride.com</strong>.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Privacy;
